import GrowthAcquisitionEpicClient from 'bundles/epic/clients/GrowthAcquisition';

export const isDegreeExcludedFromShowingEOI = (slug: string) => {
  return GrowthAcquisitionEpicClient.preview('degreesExcludedFromShowingEOI').includes(slug);
};

export default {
  isDegreeExcludedFromShowingEOI,
};
